import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAdmin(response.data);
        } catch (error) {
          console.error('Auth check failed:', error);
          localStorage.removeItem('admin_token');
          setToken(null);
          setAdmin(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem('admin_token', newToken);
    setToken(newToken);
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    localStorage.removeItem('admin_token');
    setToken(null);
    setAdmin(null);
  };

  const loginWithCredentials = async (username, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password
      });
      login(response.data.token);
      const me = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${response.data.token}` }
      });
      setAdmin(me.data);
      return { success: true, role: response.data.role };
    } catch (error) {
      console.error('Login failed:', error);
      return {
        success: false,
        message: error?.response?.data?.detail || 'Connexion impossible'
      };
    }
  };

  const value = {
    admin,
    token,
    loading,
    isAuthenticated: !!admin,
    isSuperAdmin: admin?.role === 'superadmin',
    login,
    logout,
    loginWithCredentials
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
